import { HbbTVExit } from '../../client/hbbtv';
import { webOsExit } from '../../client/webos';
import { tizenExit } from '../../client/tizen';
import { hbbTvMode, tizenMode, webOsMode } from '../../common/types';
import { Thunk } from '../../client/configureStore';

export const closeAppThunk =
  (): Thunk<Promise<void>> =>
  async (_, __, { appFeatures: { mode } }) => {
    if (mode === hbbTvMode) {
      HbbTVExit();
    } else if (mode === webOsMode) {
      webOsExit();
    } else if (mode === tizenMode) {
      tizenExit();
    } else {
      window.close();
    }

    return Promise.resolve();
  };
